var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "153.308px",
    height: "255.313px",
    viewBox: "37.505 12.873 153.308 255.313",
    enableBackground: "new 37.505 12.873 153.308 255.313",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard-66") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Left"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8A90A2",
    d: "M165,268.187c-6.763-0.002-13.247-2.689-18.028-7.472l-102-102c-9.955-9.958-9.955-26.099,0-36.057l102-102 c9.783-10.13,25.927-10.411,36.057-0.627c10.13,9.784,10.411,25.927,0.627,36.057c-0.205,0.212-0.414,0.421-0.627,0.626 l-83.971,83.972l83.971,83.972c9.957,9.96,9.954,26.105-0.005,36.063C178.242,265.5,171.76,268.185,165,268.187z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.b722b4ebd4ec158f5924830cfcc2ef70.svg";
export { ForwardRef as ReactComponent };